import React from "react";
import { isSandboxEnv } from "../lib/environment";

// ── PONTO ÚNICO de troca (rito UX do owner) ─────────────────────────────────
// COPY e COR são decisão de PRODUTO; trocar SÓ aqui (uma linha cada).
//
// (a) COR: verde do design system. Paridade com os badges "positivos" do
//     `StatusBadge` (liquidada/active/approved usam a família `emerald`).
//     Alternativa no tema: token `--zemo-success` (#16a34a claro / #4ade80 dark).
export const SANDBOX_BADGE_CLASSES = "bg-emerald-50 text-emerald-700 border-emerald-300";
// (b) COPY: o texto exibido.
export const SANDBOX_BADGE_LABEL = "Sandbox";
// (c) POSIÇÃO ratificada pelo owner (TS1-A, TRP-098): TOPO (faixa no topbar),
//     centralizada — não sobrepõe logo (esq.) nem ações (dir.) do Header.

/**
 * Badge "Sandbox": renderiza SÓ no ambiente sandbox; `null` em qualquer outro
 * (produção incluída). Montado uma vez no root (App.js). Fixo, discreto e
 * `pointer-events-none` — nunca bloqueia clique nem quebra o layout mobile.
 */
export default function SandboxBadge() {
  if (!isSandboxEnv()) return null;
  return (
    <div
      className="fixed top-3 left-1/2 -translate-x-1/2 z-50 pointer-events-none"
      data-testid="sandbox-badge"
    >
      <span
        role="status"
        aria-label={`Ambiente ${SANDBOX_BADGE_LABEL}`}
        className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-semibold shadow-sm ${SANDBOX_BADGE_CLASSES}`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" aria-hidden="true"></span>
        {SANDBOX_BADGE_LABEL}
      </span>
    </div>
  );
}
